import React from "react";
import "./styles.scss";

export const InfiniteProgressBar = () => (
  <div className="infinite-progress-bar-container">
    <div className="progress-bar">
      <div className="progress-bar-value"></div>
    </div>
  </div>
);